import { Flex, FlexProps, Text } from '@rover/kibble/core';

interface NoTrainingReviewsBoxProps {
  sx?: FlexProps['sx'];
}
export default function NoTrainingReviewsBox({ sx }: NoTrainingReviewsBoxProps): JSX.Element {
  return (
    <Flex
      width="100%"
      height="273px"
      background="secondary"
      justifyContent="center"
      alignItems="center"
      borderRadius="8px"
      sx={sx}
    >
      <Text size="100" fontWeight="semibold" textColor="tertiary">
        {/* TODO DEV-104195: Translate */}
        No available training reviews
      </Text>
    </Flex>
  );
}
